<template>
    <div>
        <h2>Edit Incident</h2>

        <div v-if="incident">
            <div class="widget" v-if="isAdmin()">
                <div class="widget-head">
                    <h3 class="heading">Details</h3>
                </div>
                <div class="widget-body">
                    <b-container>
                        <b-row class="detail-row">
                            <b-col sm="6">
                                <b-row>
                                    <b-col sm="3" class="detail-label">
                                        Submitted By
                                    </b-col>
                                    <b-col sm="9">
                                        {{ incident.submitter.firstName }} {{ incident.submitter.lastName }}
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col sm="3" class="detail-label">
                                        Email
                                    </b-col>
                                    <b-col sm="9">
                                        {{ incident.submitter.email }}
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col sm="3" class="detail-label">
                                        Department
                                    </b-col>
                                    <b-col sm="9">
                                        {{ incident.department }}
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="6">
                                <b-row>
                                    <b-col sm="3" class="detail-label">
                                        Incident Date
                                    </b-col>
                                    <b-col sm="9">
                                        {{ incident.incidentDate  | moment("MM/DD/YYYY") }}
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col sm="3" class="detail-label">
                                        Recommendation Status
                                    </b-col>
                                    <b-col sm="9">
                                        <span v-if="incident.incidentRecommendation">{{ incident.incidentRecommendation.name }}</span>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row class="detail-row">
                            <b-col sm="6">
                                <b-row>
                                    <b-col sm="3" class="detail-label">
                                        Student
                                    </b-col>
                                    <b-col sm="9">
                                        <span v-if="incident.student">{{ incident.student.firstName }} {{ incident.student.lastName }} ({{ incident.student.asuriteId }})</span>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col sm="3" class="detail-label">
                                        Email
                                    </b-col>
                                    <b-col sm="9">
                                        <span v-if="incident.student">{{ incident.student.asuemailAddress }}</span>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col sm="3" class="detail-label">
                                        Major
                                    </b-col>
                                    <b-col sm="9">
                                        {{ incident.major }}
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col sm="3" class="detail-label">
                                        Year
                                    </b-col>
                                    <b-col sm="9">
                                        {{ incident.year }}
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="6">
                                <b-row>
                                    <b-col sm="3" class="detail-label">
                                        Course
                                    </b-col>
                                    <b-col sm="9">
                                        <span v-if="incident.studentCourse">
                                            {{ incident.studentCourse.subjectCode }} {{ incident.studentCourse.catalogNumber }}
                                            ({{ incident.studentCourse.classNumber }})
                                        </span>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col sm="3" class="detail-label">
                                        Title
                                    </b-col>
                                    <b-col sm="9">
                                        <span v-if="incident.studentCourse">{{ incident.studentCourse.courseTitle }}</span>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col sm="3" class="detail-label">
                                        Instructor
                                    </b-col>
                                    <b-col sm="9">
                                        <span v-if="incident.studentCourse">{{ incident.studentCourse.instructor }}</span>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col sm="3" class="detail-label">
                                        Term
                                    </b-col>
                                    <b-col sm="9">
                                        <span v-if="incident.studentCourse">{{ incident.studentCourse.termCode }}</span>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>
            </div>

            <div class="widget" v-if="isAdmin()">
                <div class="widget-head">
                    <h3 class="heading">Description</h3>
                </div>
                <div class="widget-body">
                    <p v-html="getDecodedHtml(incident.description)"></p>
                </div>
            </div>

            <b-form class="form-horizontal" @submit.prevent="submitIncident">

                <b-form-group label="Student"
                              label-class="control-label"
                              :class="{ 'invalid-group': $v.incident.student.$error }"
                              v-if="isFaculty()">
                    <autocomplete ref="studentAutocomplete"
                                  :source="studentApiEndpoint"
                                  placeholder="Search students"
                                  :inputClass="{ 'form-control': true, 'is-invalid': $v.incident.student.$error }"
                                  resultsValue="asuriteId"
                                  :resultsDisplay="userDisplay"
                                  @selected="selectStudent"
                                  @clear="clearStudent"
                                  credentials="include"
                                  :initialDisplay="getStudentName()"></autocomplete>
                    <span class="span-feedback invalid-feedback" v-if="$v.incident.student.$error">You must select a student.</span>

                    <b-row v-if="incident.student" class="student-details">
                        <b-col sm="1" class="student-detail-label">
                            <p>Name</p>
                            <p>AsuriteId</p>
                            <p>AffiliateId</p>
                            <p>Email</p>
                            <p>Admit Term</p>
                        </b-col>
                        <b-col sm="10">
                            <p>{{incident.student.firstName}} {{incident.student.lastName}}</p>
                            <p>{{incident.student.asuriteId}}</p>
                            <p>{{incident.student.affiliateId}}</p>
                            <p>{{incident.student.asuemailAddress}}</p>
                            <p>{{displaySemester(incident.student.termAdmitted)}}</p>
                        </b-col>
                    </b-row>
                </b-form-group>

                <b-form-group label="Course"
                              label-class="control-label"
                              :class="{ 'invalid-group': $v.incident.studentCourse.$error }"
                              v-if="isFaculty()">
                    <autocomplete ref="courseAutocomplete"
                                    :source="courseQuery"
                                    placeholder="Search courses"
                                    :inputClass="{ 'form-control': true, 'is-invalid': $v.incident.studentCourse.$error }"
                                    resultsValue="id"
                                    :resultsDisplay="courseDisplay"
                                    :disableInput="!incident.student"
                                    :disabled="incident.student"
                                    :class="{ 'disabled-autoselect': !incident.student }"
                                    @selected="selectCourse"
                                    @clear="clearCourse"
                                    credentials="include"
                                    :initialDisplay="getCourseDisplay()"></autocomplete>
                    <span class="span-feedback invalid-feedback" v-if="$v.incident.studentCourse.$error">You must select a course.</span>
                    <span v-if="incident.student && !coursesFound">No courses could be found for this student.</span>
                </b-form-group>

                <b-form-group label="Incident Date"
                              label-class="control-label"
                              :class="{ 'invalid-group': $v.incident.incidentDate.$error }"
                              v-if="isFaculty()">
                    <datepicker v-model="incident.incidentDate"
                                :inputClass="{ 'form-control': true, 'is-invalid': $v.incident.incidentDate.$error }"
                                format="MM/dd/yyyy"></datepicker>
                    <span class="span-feedback invalid-feedback" v-if="$v.incident.incidentDate.$error">You must enter an incident date.</span>
                </b-form-group>

                <b-form-group label="Recommendation"
                              label-class="control-label"
                              :class="{ 'invalid-group': $v.incident.incidentRecommendationId.$error }"
                              v-if="isFaculty()">
                    <b-form-select v-model="incident.incidentRecommendationId"
                                   :options="sortedRecommendations"
                                   value-field="id"
                                   text-field="name"
                                   :class="{ 'is-invalid': $v.incident.incidentRecommendationId.$error }">
                    </b-form-select>
                    <span class="span-feedback invalid-feedback"
                          v-if="$v.incident.incidentRecommendationId.$error">You must select a recommendation.</span>
                </b-form-group>

                <b-form-group label="Description"
                              label-class="control-label"
                              :class="{ 'invalid-group': $v.incident.description.$error }"
                              v-if="isFaculty()">
                    <vue-editor id="descriptionEditor"
                                v-model="incident.description"></vue-editor>
                    <span class="span-feedback invalid-feedback" v-if="$v.incident.description.$error">You must enter a description.</span>
                </b-form-group>

                <b-form-group label="Status" label-class="control-label" v-if="isAdmin()">
                    <b-form-select v-model="selectedStatusDefinitionId"
                                    :options="sortedStatusDefinitions"
                                    value-field="id"
                                    text-field="name"
                                    @change="selectStatusDefinition"></b-form-select>
                </b-form-group>

                <b-form-group label="Disposition"
                                label-class="control-label"
                                v-if="incident.incidentStatuses.length > 0 && incident.incidentStatuses[0].incidentStatusDefinition.name === 'Final Disposition' && isAdmin()">
                    <vue-editor id="dispositionEditor" v-model="incident.disposition"></vue-editor>
                </b-form-group>

                <b-form-group label="Student Filing Grievance" label-class="control-label" v-if="isAdmin()">
                    <b-form-select v-model="incident.studentFilingGrievance" @change="clearStudentGrievance">
                        <option :value="true">Yes</option>
                        <option :value="false">No</option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label="Student Grievance" label-class="control-label" v-if="incident.studentFilingGrievance && isAdmin()">
                    <vue-editor id="grievanceEditor" v-model="incident.studentGrievance"></vue-editor>
                </b-form-group>

                <b-form-group label="Follow Up" label-class="control-label">
                    <vue-editor id="followUpEditor" v-model="incident.followUp"></vue-editor>
                </b-form-group>

                <div class="margin-bottom-none add-top-margin">
                    <b-button type="submit" class="pull-right" variant="primary">Save</b-button>
                    <b-form-checkbox class="pull-right" v-model="notifyFaculty" v-if="isAdmin()">
                        Notify faculty of changes
                    </b-form-checkbox>
                </div>
            </b-form>
        </div>
    </div>
</template>

<script>
// text editor
import { VueEditor } from "vue2-editor";

import toastr from "toastr";
import { mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import studentsApi from "../../api/students";
import incidentsApi from "../../api/incidents";

var htmlEncode = require("js-htmlencode").htmlEncode;
var htmlDecode = require("js-htmlencode").htmlDecode;

export default {
  data() {
    return {
      selectedStatusDefinitionId: null,
      notifyFaculty: false,
      coursesFound: true
    };
  },

  props: {
    incident: {
      required: true
    },

    statusDefinitions: {
      type: Array,
      required: true
    },

    recommendations: {
      type: Array,
      required: true
    }
  },

  validations: {
    incident: {
      student: {
        required
      },

      studentCourse: {
        required
      },

      incidentDate: {
        required
      },

      incidentRecommendationId: {
        required
      },

      description: {
        required
      }
    }
  },

  watch: {
    incident: function() {
      if (this.incident.incidentStatuses.length > 0) {
        this.selectedStatusDefinitionId = this.incident.incidentStatuses[0].id;
      }
    }
  },

  components: {
    VueEditor
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),

    // sort statusDefinitions by SortOrder
    sortedStatusDefinitions: function() {
      return _.sortBy(this.statusDefinitions, function(statusDefinition) {
        return statusDefinition.sortOrder;
      });
    },

    studentApiEndpoint: function() {
      return process.env.VUE_APP_BASE_URI + "/api/Students/FindStudent?query=";
    },

    // only query the api if a student has been selected
    courseQuery: function() {
      if (this.incident.student) {
        return (
          process.env.VUE_APP_BASE_URI +
          "/api/Students/FindStudentCourses/" +
          this.incident.student.asuriteId +
          "?query="
        );
      } else {
        return [];
      }
    },

    // sort recommendations by SortOrder
    sortedRecommendations: function() {
      return _.sortBy(this.recommendations, function(recommendation) {
        return recommendation.sortOrder;
      });
    }
  },

  methods: {
    getDecodedHtml(encodedString) {
      return htmlDecode(encodedString);
    },

    isAdmin: function() {
      return _.find(this.user.userRoles, function(userRole) {
        return userRole === "Incidents.Admin";
      });
    },

    isFaculty: function() {
      return _.find(this.user.userRoles, function(userRole) {
        return userRole === "Incidents.Faculty";
      });
    },

    userDisplay: function(user) {
      return user.firstName + " " + user.lastName;
    },

    courseDisplay: function(course) {
      return (
        course.subjectCode +
        " " +
        course.catalogNumber +
        " #" +
        course.classNumber +
        " - " +
        this.displaySemester(course.termCode)
      );
    },

    // either uses the userDisplay function to get the name of the current student, or returns empty string
    getStudentName: function() {
      if (this.incident && this.incident.student) {
        return this.userDisplay(this.incident.student);
      } else {
        return "";
      }
    },

    // either uses the courseDisplay function to get the display for the curent course, or returns empty string
    getCourseDisplay: function() {
      if (this.incident && this.incident.studentCourse) {
        return this.courseDisplay(this.incident.studentCourse);
      } else {
        return "";
      }
    },

    selectStudent: function(autoselectResponse) {
      this.incident.student = autoselectResponse.selectedObject;
      this.incident.studentId = autoselectResponse.selectedObject.asuriteId;
      this.clearCourse();
      this.checkForCourses();
    },

    clearStudent: function() {
      this.incident.student = null;
      this.incident.studentId = null;
      this.clearCourse();
    },

    selectCourse: function(autoselectResponse) {
      this.incident.studentCourse = autoselectResponse.selectedObject;
      this.incident.studentCourseId = autoselectResponse.selectedObject.id;
    },

    clearCourse: function() {
      this.incident.studentCourse = null;
      this.incident.studentCourseId = null;
      // necessary to clear out the text from the course autoselect
      this.$refs.courseAutocomplete.display = "";
    },

    // check that there are courses for selected student
    checkForCourses: function() {
      var that = this;
      if (this.incident.student) {
        studentsApi
          .getStudentCourses(this.incident.student.asuriteId)
          .then(function(response) {
            if (response.data.length > 0) {
              that.coursesFound = true;
            } else {
              that.coursesFound = false;
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      } else {
        this.coursesFound = false;
      }
    },

    // when statusDefinition is picked from dropdown, set it as selected statusDefinition
    selectStatusDefinition: function(statusDefinitionId) {
      this.incident.incidentStatuses = [];
      if (statusDefinitionId !== null) {
        var newIncidentStatusDefinition = _.find(
          this.statusDefinitions,
          function(statusDefinition) {
            return statusDefinition.id === statusDefinitionId;
          }
        );
        var incidentStatusObject = {
          active: true,
          createdBy: null,
          createdDate: null,
          effectiveDate: null,
          id: 0,
          incident: null,
          incidentId: this.incident.id,
          incidentStatusDefinition: newIncidentStatusDefinition,
          incidentStatusDefinitionId: statusDefinitionId,
          modifiedBy: null,
          modifiedDate: null
        };
        this.incident.incidentStatuses.push(incidentStatusObject);
      }
      // clear text from disposition field
      this.incident.disposition = null;
    },

    clearStudentGrievance: function() {
      this.incident.studentGrievance = null;
    },

    displaySemester: function(termCode) {
      // if termCode is null, return empty string
      if (!termCode) {
        return "";
      }

      // Year starts with 20
      var semesterString = "20";

      // Last digits of year are the middle two digits of termCode
      semesterString += termCode.substring(1, 3);
      semesterString += " ";

      // Season (fall, winter, etc.) is determined by last digit of termCode
      var seasonId = termCode[3];
      if (seasonId === "1") {
        semesterString += "Spring";
      } else if (seasonId === "4") {
        semesterString += "Summer";
      } else if (seasonId === "7") {
        semesterString += "Fall";
      } else if (seasonId === "9") {
        semesterString += "Winter Intersession";
      }
      return semesterString;
    },

    submitIncident: function() {
      var that = this;
      this.$v.$touch();

      // only submit if the form is valid
      if (!this.$v.$invalid) {
        this.incident.description = htmlEncode(this.incident.description);
        this.incident.disposition = htmlEncode(this.incident.disposition);
        this.incident.studentGrievance = htmlEncode(
          this.incident.studentGrievance
        );
        this.incident.followUp = htmlEncode(this.incident.followUp);

        incidentsApi
          .editIncident(this.incident)
          .then(function(response) {
            toastr.options = {
              closeButton: true,
              debug: false,
              newestOnTop: false,
              progressBar: false,
              positionClass: "toast-top-right",
              preventDuplicates: false,
              onclick: null,
              showDuration: "300",
              hideDuration: "0",
              timeOut: "5000",
              extendedTimeOut: "1000",
              showEasing: "swing",
              hideEasing: "linear",
              showMethod: "fadeIn",
              hideMethod: "fadeOut"
            };

            // Toastr Message
            toastr.success("Your incident has been edited.", "Success");

            // if notify faculty has been checked, send email
            if (that.notifyFaculty) {
              incidentsApi
                .createIncidentEmail(
                  response.data.id,
                  "An incident has been updated"
                )
                .then(function() {
                  that.$router.push({
                    name: "incident",
                    params: { incidentId: response.data.id }
                  });
                })
                .catch(function(error) {
                  console.log(error);
                });
            } else {
              that.$router.push({
                name: "incident",
                params: { incidentId: response.data.id }
              });
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 100%;
}

.detail-label {
  text-align: right;
  font-weight: bold;
}

.widget-body {
  font-size: 14px;
}

.detail-row {
  margin: 20px 0 20px 0;
}

.control-label {
  padding-bottom: 0;
}
</style>
